module.exports = __webpack_public_path__ + "static/media/205-switzerland.ba835bc3.svg";